import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { FileEdit, Eye, Pencil, Trash2 } from 'lucide-react';
import SectionHeader from './SectionHeader';

const CoverLettersSection = ({ 
  coverLetters, 
  sectionOrder, 
  onMoveSectionUp, 
  onMoveSectionDown, 
  onDeleteCoverLetter,
  isVisible 
}) => {
  const navigate = useNavigate();

  if (!isVisible || coverLetters.length === 0) return null;

  return (
    <div className="mb-12">
      <SectionHeader 
        title="Recent Cover Letters" 
        sectionId="coverLetters"
        viewAllPath="/cover-letters"
        viewAllColor="orange"
        sectionOrder={sectionOrder}
        onMoveSectionUp={onMoveSectionUp}
        onMoveSectionDown={onMoveSectionDown}
      />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
        {coverLetters.slice(0, 3).map((letter) => (
          <div
            key={letter.id}
            className="p-4 sm:p-6 bg-white rounded-xl sm:rounded-2xl border border-gray-200 hover:shadow-lg transition-shadow"
            data-testid={`cover-letter-card-${letter.id}`}
          >
            <div className="w-10 h-10 bg-gradient-to-br from-orange-500 to-orange-600 rounded-lg flex items-center justify-center mb-3 sm:mb-4">
              <FileEdit className="w-5 h-5 text-white" />
            </div>
            <h3 className="font-semibold text-sm sm:text-base mb-1 line-clamp-1">{letter.job_title}</h3>
            <p className="text-xs sm:text-sm text-gray-600 mb-1 sm:mb-2 line-clamp-1">{letter.company}</p>
            <p className="text-xs text-gray-500 mb-3 sm:mb-4">
              Created {new Date(letter.created_at).toLocaleDateString()}
            </p>
            <div className="flex flex-wrap gap-2">
              <Button
                size="sm"
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(`/cover-letter-view/${letter.id}`);
                }}
                variant="outline"
                className="border-orange-200 text-orange-600 hover:bg-orange-50 text-xs px-2 sm:px-3 min-h-[36px]"
              >
                <Eye className="w-3 h-3 sm:mr-1" />
                <span className="hidden sm:inline">View</span>
              </Button>
              <Button
                size="sm"
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(`/cover-letter?edit=${letter.id}`);
                }}
                className="bg-orange-600 hover:bg-orange-700 text-white text-xs px-2 sm:px-3 min-h-[36px]"
              >
                <Pencil className="w-3 h-3 sm:mr-1" />
                <span className="hidden sm:inline">Edit</span>
              </Button>
              <Button
                size="sm"
                variant="outline"
                onClick={(e) => {
                  e.stopPropagation();
                  onDeleteCoverLetter(letter.id);
                }}
                className="border-red-200 text-red-600 hover:bg-red-50 text-xs px-2 sm:px-3 min-h-[36px]"
              >
                <Trash2 className="w-3 h-3 sm:mr-1" />
                <span className="hidden sm:inline">Delete</span>
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CoverLettersSection;
